"use strict";

TYCOON.pageScript = TYCOON.pageScript || {
  init: {}
};
TYCOON.pageScript = function () {
  // コンストラクタ  =================================================================
  function init() {}
  return {
    init: init
  };
}();
TYCOON.common.init(TYCOON.pageScript.init);